import { render, staticRenderFns } from "./single_dat.vue?vue&type=template&id=ccab33c6"
import script from "./single_dat.vue?vue&type=script&lang=js"
export * from "./single_dat.vue?vue&type=script&lang=js"
import style0 from "./single_dat.vue?vue&type=style&index=0&id=ccab33c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports